module.exports = __webpack_public_path__ + "img/additional-icon.63eeb291.png";